import { render } from "./MyProfile.vue?vue&type=template&id=48be37d6"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=48be37d6&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__